import React from "react";
import TabPages from "../components/TabPages";
import SavingsLedger from "./SavingsLedger";
import CoWorkers from "./CoWorkers";

export default function SavingsHub() {
  return (
    <TabPages
      testId="savings-hub-page"
      tabPrefix="savings"
      defaultTab="ledger"
      tabs={[
        { id: "ledger", label: "Savings Ledger", render: () => <SavingsLedger /> },
        { id: "coworkers", label: "ASTRA Co-Workers", render: () => <CoWorkers /> },
      ]}
    />
  );
}
